import { useNavigate, useRouter } from '@tanstack/react-router'
import { useCallback, useEffect, useRef } from 'react'

import { pushBackHandler } from './telegram'

export type BackTarget = '/' | '/more' | '/products' | '/history' | '/spf' | '/week'

export function useGoBack(fallback: BackTarget = '/more'): () => void {
  const router = useRouter()
  const navigate = useNavigate()

  return useCallback(() => {
    if (router.history.canGoBack()) {
      router.history.back()
      return
    }
    void navigate({ to: fallback })
  }, [router, navigate, fallback])
}

export function useBackButton(handler: () => void, active = true): void {
  const latest = useRef(handler)

  useEffect(() => {
    latest.current = handler
  })

  useEffect(() => {
    if (!active) return
    return pushBackHandler(() => latest.current())
  }, [active])
}
